import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { useMutation } from '@tanstack/react-query'
import { updateOrganizationUserActivationOrganizationOrganizationIdUsersUseruuidActivationPutMutation } from '@/generated/@tanstack/react-query.gen'
import { toast } from '@/components/custom-toast'
import { DialogClose, DialogDescription } from '@radix-ui/react-dialog'
import { useUser } from '@/pages/enterprise/user-provider'

interface IProps {
  organizationId: number
  userId: string
  email: string
  isActivated: boolean
  onStatusChanged: () => void
  open: boolean
  setOpen: (open: boolean) => void
  isHiddenTrigger?: boolean
}

export default function ActivateUserModal(props: IProps) {
  const { open, setOpen, isHiddenTrigger } = props
  const { onUpdateSeats } = useUser()
  const mutate = useMutation({
    ...updateOrganizationUserActivationOrganizationOrganizationIdUsersUseruuidActivationPutMutation(
      {}
    ),
    onError: (error) => {
      toast.error({
        message:
          (error.response?.data.detail as unknown as string) ?? error.message,
      })
    },
    onSuccess: () => {
      onUpdateSeats()
      props.onStatusChanged()
      toast.success({
        message: `User ${
          props.isActivated ? 'deactivated' : 'activated'
        } successfully.`,
      })
      setOpen(false)
    },
  })

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      {isHiddenTrigger ? null : (
        <DialogTrigger asChild>
          <Button variant={'window'} size={'sm'}>
            {props.isActivated ? 'Deactivate' : 'Activate'}
          </Button>
        </DialogTrigger>
      )}
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {props.isActivated ? 'Deactivate User' : 'Activate User'}
          </DialogTitle>
        </DialogHeader>
        <DialogDescription>
          {props.isActivated
            ? 'Are you sure you want to deactivate this user?'
            : 'Are you sure you want to activate this user?'}
        </DialogDescription>
        <DialogFooter className="flex !justify-start">
          <Button
            disabled={mutate.isPending}
            onClick={() => {
              mutate.mutate({
                path: {
                  organization_id: props.organizationId,
                  useruuid: props.userId,
                },
                body: { activation: props.isActivated ? 0 : 2 },
              })
            }}
          >
            {props.isActivated ? 'Deactivate' : 'Activate'}
          </Button>
          <DialogClose asChild>
            <Button
              variant="ghost"
              className="text-primary hover:text-emerald-500 hover:bg-transparent"
            >
              Cancel
            </Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
